module.exports = __webpack_public_path__ + "static/hospital-78b8e739144d20d7eb1a2a7881baa4e8.jpg";